var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-group shadow" },
    _vm._l(_vm.matchedItems, function(item, id) {
      return _c("vue-bootstrap-typeahead-list-item", {
        key: id,
        attrs: {
          data: item.data,
          "html-text": _vm.highlight(item.text),
          "background-variant": _vm.backgroundVariant,
          "text-variant": _vm.textVariant
        },
        nativeOn: {
          click: function($event) {
            return _vm.handleHit(item, $event)
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "suggestion",
              fn: function(ref) {
                var data = ref.data
                var htmlText = ref.htmlText
                return _vm.$scopedSlots.suggestion
                  ? [
                      _vm._t("suggestion", null, null, {
                        data: data,
                        htmlText: htmlText
                      })
                    ]
                  : undefined
              }
            }
          ],
          null,
          true
        )
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dde7c978", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dde7c978","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-bootstrap-typeahead/src/components/VueBootstrapTypeaheadList.vue
// module id = 1677
// module chunks = 116